import category from './category';
import tag from './tag';
import page from './page';
import JobOpportunities from './page-job-opportunities';
import single from './single';

export default {
  category,
  tag,
  page,
  single,
  'template-Job Opportunities': JobOpportunities,
};
